module.exports = "<app-project-modal-timelog-edit></app-project-modal-timelog-edit>\r\n<app-project-time-datatable></app-project-time-datatable>\r\n"